import { createContext, ReactNode, useContext, useMemo } from 'react';

import FullBuyAnalytics from '~/src/features/full-buy/analytics';

export type TFullBuyContextProperties = {
    analytics: FullBuyAnalytics,
    isVillage: boolean,
}

export const FullBuyContext = createContext<TFullBuyContextProperties>({
    analytics: new FullBuyAnalytics(),
    isVillage: false,
});

export const useAnalytics = (): FullBuyAnalytics => {
    const fullBuyCtx = useContext(FullBuyContext);

    if (!fullBuyCtx) {
        throw new Error('useAnalytics must be used within an AnalyticsProvider');
    }

    const { analytics } = fullBuyCtx;

    return useMemo(() => analytics, [analytics]);
};

type TFullBuyProviderProperties = {
    analytics: FullBuyAnalytics,
    isVillage?: boolean,
    children: ReactNode,
}

const FullBuyProvider = ({ analytics, isVillage = false, children }: TFullBuyProviderProperties) => {
    return (
        <FullBuyContext.Provider value={{ analytics, isVillage }}>
            {children}
        </FullBuyContext.Provider>
    );
};

export default FullBuyProvider;
